var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'card': !_vm.inset }},[_c('div',{class:{ 'card-body': !_vm.inset }},[_c('div',{staticClass:"text-center my-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"mr-3"},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spin fa-circle-o-notch fa-fw"})]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('span',[_c('i',{class:("fa " + _vm.leaderboardViewIcon + " fa-fw")})]):_vm._e()]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"size":"sm","options":[
            {
              text: 'Today',
              value: 'day'
            },
            {
              text: '7 Days',
              value: 'last7days'
            },
            {
              text: '30 Days',
              value: 'last30days'
            },
            {
              text: 'YTD',
              value: 'ytd'
            }
          ],"button-variant":_vm.radioButtonVariant,"buttons":""},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1)]),_vm._v(" "),_c('widget',{ref:"leaderboardWidget",staticClass:"mb-3",model:{value:(_vm.leaderboardWidgetConfig),callback:function ($$v) {_vm.leaderboardWidgetConfig=$$v},expression:"leaderboardWidgetConfig"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }